export const NO = { id: 'no', label: 'No' };
export const PRE_CONCEPTIONAL = {
  id: 'pre_conceptional',
  label: 'Sì, assunzione già in epoca pre-concezionale',
};
export const DURING_PREGNANCY = {
  id: 'during_pregnancy',
  label: 'Sì, assunzione nel corso della gravidanza',
};
